import {
  ResponsiveGridLayouts,
  ChartType,
} from '@jupiterone/jupiter-web-toolkit';
import uuidV4 from 'uuid/v4';
import { InsightsBoard, Widget } from 'jupiter-web-insights/src/types';

const QUERY_PIE_ENTITIES_ADDED_LAST_48_HOURS_BY_TYPE = `FIND * with _createdOn > date.now -48 hours as e
return e._type as name, count(e) as value`;

const QUERY_PIE_RESOURCE_COUNT_BY_TYPE = `Find * with _source!='system-mapper' as e
return e._type as name, count(e) as value`;

const QUERY_PIE_MAPPED_RESOURCE_COUNT_BY_TYPE = `Find * with _source!='system-mapper' as e
return e._type as name, count(e) as value`;

export const HOME_INSIGHTS_BOARD: InsightsBoard = {
  id: 'home',
  name: 'Home Dashboard',
};

export const HOME_WIDGETS: Widget[] = [
  {
    id: uuidV4(),
    title: 'What was added in the last 48 hours?',
    type: ChartType.Pie,
    config: {
      queries: [
        {
          name: 'query1',
          query: QUERY_PIE_ENTITIES_ADDED_LAST_48_HOURS_BY_TYPE,
        },
      ],
    },
  },
  {
    id: uuidV4(),
    title: 'Resource Count by Type',
    type: ChartType.Pie,
    config: {
      queries: [
        {
          name: 'query1',
          query: QUERY_PIE_RESOURCE_COUNT_BY_TYPE,
        },
      ],
    },
  },
  {
    id: uuidV4(),
    title: 'Mapped Resources by Type',
    type: ChartType.Pie,
    config: {
      queries: [
        {
          name: 'query1',
          query: QUERY_PIE_MAPPED_RESOURCE_COUNT_BY_TYPE,
        },
      ],
    },
  },
];

export const HOME_WIDGET_LAYOUTS: ResponsiveGridLayouts = {
  xs: [],
  sm: [],
  md: [],
  lg: [
    {
      i: HOME_WIDGETS[0].id,
      x: 0,
      y: 0,
      h: 2,
      w: 4,
    },
    {
      i: HOME_WIDGETS[1].id,
      x: 4,
      y: 0,
      h: 2,
      w: 4,
    },
    {
      i: HOME_WIDGETS[2].id,
      x: 8,
      y: 0,
      h: 2,
      w: 4,
    },
  ],
  xl: [],
};
